<!-- 用户协议 -->
<template>
	<div class="">
		<CPopup
			v-model="is_show"
			title="用户协议"
		>
			<div
				style="max-height:50vh;overflow-y:auto;"
				v-html="user_arge"
			></div>
		</CPopup>
	</div>
</template>

<script>
import CPopup from "@/components/CPopup.vue"
export default {
	components: { CPopup },
	data() {
		return {
			is_show: false,
			user_arge: "", // 用户协议
		}
	},
	created() {
		this.$eventBus.$on("SHOW_USER_ARGE", _ => {
			this.is_show = true
		})

		this.$post("v1.index/get_config", { type: 2 }).then(res => { this.user_arge = res.data || "" });
	},
	methods: {},
}
</script>

<style lang='scss' scoped></style>